/**
 * Enums
 *
 * Developed By : Travancore Analytics (2022)
 * Author: Akhil Soman
 * Created on: 09/03/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      09/03/2025    Akhil Soman       Creating new File
 */

export enum RoutePath {
  Home = "/",
  KnowledgeHub = "/knowledgehub",
  QuestionForm = "/questions",
  Topic = "/topics",
  UserManagement = "/user-management",
  Assets = "/assets",
  AssessmentQuestion = "/assessments",
  AssessmentById = "/assessment/:assessmentId",
  AssessmentSummary = "/assessment-summary",
  AssessmentManagement = "/assessment-management",
  AssetCategory = "/asset-category",
}

export enum RouteKey {
  Home = "1",
  KnowledgeHub = "2",
  QuestionForm = "3",
  Topic = "4",
  UserManagement = "5",
  Assets = "6",
  AssessmentQuestion = "7",
  AssessmentManagement = "8",
  AssetCategory = "9",
}

export enum userType {
  Group = "2",
  Admin = "1",
  Individual = "0",
  Guest = "-1",
}
export const userTypeKey = {
  "2": "Group",
  "1": "Admin",
  "0": "Individual",
  "-1": "Guest",
} as const;
